import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { COLORS, ICONS } from 'compositions/constants/constants';

const StyledIcon = styled.svg`
  display: inline-block;
  height: ${iconProps => iconProps.size};
  margin-top: -0.2em;
  vertical-align: middle;
  width: ${iconProps => iconProps.size};
  path {
    fill: ${iconProps => iconProps.getColor};
  }
`;

const Icon = props => {
  const camelize = str => {
    return str
      .toString()
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, '');
  };
  const name = props.name && camelize(props.name);
  const icon = ICONS[name] || ICONS.question;
  const theme = {
    colors: {
      ...COLORS,
      ...props.theme.colors,
    },
  };
  const color = theme.colors[props.color] || props.color;
  return (
    <ThemeProvider theme={theme}>
      <StyledIcon
        aria-hidden="true"
        role="presentation"
        getColor={color}
        viewBox={`0 0 ${icon.width} ${icon.height}`}
        size={props.size}
        transform={icon.transform}
        {...props}
      >
        {icon.paths.map((path, index) => (
          <path key={index} d={path} />
        ))}
      </StyledIcon>
    </ThemeProvider>
  );
};

Icon.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  transform: PropTypes.string,
  theme: PropTypes.object,
};

Icon.defaultProps = {
  color: 'currentColor',
  size: '1.1em',
  theme: {},
};

export default withTheme(Icon);
